import { defineMessages } from '@approvalmax/utils';

export const messages = defineMessages('app.TwoFaHardEnforcementPage.HardEnforcementWizard', {
    title: 'Install Authentication app to log in',
    buttonProceed: 'Proceed',
    buttonNext: 'Continue',
    buttonPrev: 'Go back',
});
